var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.785 0.582031C13.3424 0.582031 0.625 13.2996 0.625 28.7421C0.625 44.1847 13.3424 56.902 28.785 56.902C44.2276 56.902 56.945 44.1847 56.945 28.7421C56.945 12.9968 44.2276 0.582031 28.785 0.582031ZM45.7416 16.933L21.2151 41.1566H20.9123L11.2228 25.1085C16.6732 25.1085 20.9123 30.5589 21.5179 31.1644C21.5179 31.1644 21.5179 31.1644 21.8207 31.1644L45.7416 16.933C45.4388 16.6302 45.7416 16.6302 45.7416 16.933Z",
    fill: "#39B44A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a301455bc9b448b0204d61322a22bf30.svg";
export { ForwardRef as ReactComponent };